import { createApiRequester } from './request'

export const useApi = createApiRequester('client')
